export interface DateTimeFormatOption {
    value: string
    label: string
    description: string
}

export const CUSTOM_FORMAT_VALUE = '__custom__'

export const DEFAULT_TIME_FORMAT = 'HH:mm:ss'
export const DEFAULT_DATE_FORMAT = 'DD MMMM YYYY'

export const TIME_FORMATS: DateTimeFormatOption[] = [
    {
        value: 'HH:mm:ss',
        label: 'widget.clock.time.format.24hWithSeconds',
        description: '24:00:00 (24-hour with seconds)'
    },
    {
        value: 'HH:mm',
        label: 'widget.clock.time.format.24h',
        description: '24:00 (24-hour)'
    },
    {
        value: 'hh:mm:ss a',
        label: 'widget.clock.time.format.12hWithSeconds',
        description: '12:00:00 PM (12-hour with seconds)'
    },
    {
        value: 'hh:mm a',
        label: 'widget.clock.time.format.12h',
        description: '12:00 PM (12-hour)'
    },
    {
        value: CUSTOM_FORMAT_VALUE,
        label: 'common.custom',
        description: 'Custom format'
    }
]

export const DATE_FORMATS: DateTimeFormatOption[] = [
    {
        value: 'DD MMMM YYYY',
        label: 'widget.clock.date.format.dayMonthYear',
        description: '15 December 2024 (Day Month Year)'
    },
    {
        value: 'DD.MM.YYYY',
        label: 'widget.clock.date.format.dayMonthYearDot',
        description: '15.12.2024 (DD.MM.YYYY)'
    },
    {
        value: 'DD MMM YYYY',
        label: 'widget.clock.date.format.dayShortMonthYear',
        description: '15 Dec 2024 (Day Short Month Year)'
    },
    {
        value: 'MMM DD',
        label: 'widget.clock.date.format.monthDay',
        description: 'Dec 15 (Month Day)'
    },
    {
        value: CUSTOM_FORMAT_VALUE,
        label: 'common.custom',
        description: 'Custom format'
    }
]